<div>
    @if(label) {
    <label class="font-semibold text-gray-500 mb-2">{{ label }}</label>
    }
    <div #textareaElement class="border border-gray-200 rounded-lg" [ngClass]="{ 'theme-border': textAreaVisible }"
        (click)="showTextArea($event)">

        @if(!textAreaVisible) {
        <div class="text-sm p-4">
            @if(placeholderTitle || showIcon) {
            <div class="flex gap-2 mb-2">
                @if(showIcon) {
                <img [src]="iconSrc" [pTooltip]="iconTooltip" tooltipPosition="top" class="h-5 w-5" alt="Icon">
                }
                @if(placeholderTitle) {
                <span class="font-medium theme-text">{{ placeholderTitle | textCase }}</span>
                }
            </div>
            }
            @if(placeholderItems.length > 0) {
            <ul class="list-disc text-sm text-gray-500 mb-4 space-y-1 ml-4 font-medium italic">
                @for(item of placeholderItems; track $index) {
                <li>{{ item | textCase }}</li>
                }
            </ul>
            }
        </div>
        } @else {
        <div class="relative inline-block w-full h-full">
            <textarea pInputTextarea class="w-full h-full border-none expandable-textarea-input" [autoResize]="true"
                [rows]="rows" [maxlength]="maxLength" [placeholder]="placeholder" [(ngModel)]="value"
                (ngModelChange)="onValueChange()" (input)="onInput($event)" (paste)="onPaste()" (cut)="onCut()">
            </textarea>
            <span class="absolute bottom-2 right-3 text-xs text-gray-500">
                {{ charCount }}/{{ maxLength }}
            </span>
        </div>
        }
    </div>
</div>